import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import {Props} from './model';

const View: React.FC<Props> = ({children, open, onClose, variant, keepMounted}) => {
  return (
    <Drawer open={open} anchor='right' onClose={onClose} variant={variant} keepMounted={keepMounted}>
      {children}
    </Drawer>
  );
};

export default View;
